function getUniqueList(arr, key) {
    return arr.filter(function (item, index) {
        var i = arr.findIndex(function (e) { return e[key] === item[key]; });
        return index === i;
    });
}
export default getUniqueList;
//# sourceMappingURL=getUniqueList.js.map